// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3gm-3","bigColWidth":"Table_bigColWidth__2RRwW","biggerColWidth":"Table_biggerColWidth__O2xjO","row":"Table_row__13Sjj","col":"Table_col__1lYSE"};